import styled from '@emotion/styled';
import { BodyXSmall, LightXSmall, TitleXSmall } from '../../text/Typography';

export const ListFieldset = styled('fieldset')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const ListLabel = styled(TitleXSmall)`
    margin-bottom: 0.5rem;
`;

export const ListInputRow = styled('div')`
    padding: 0.5rem 0;
    display: flex;
    gap: 1rem;
    align-items: center;
    flex-direction: row;
    flex-grow: 1;
`;

export const ListInputBox = styled('div')`
    width: 100%;
`;

export const ListErrorText = styled(BodyXSmall)`
    transition: all 0.3s;
    color: ${({ theme }) => theme.color.error};
`;

export const ListDescription = styled(LightXSmall)`
    align-self: flex-start;
`;
